module.exports = __webpack_public_path__ + "img/step4.e2c8f3b5.png";